// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"j5ASf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarContext", ()=>CalendarContext);
parcelHelpers.export(exports, "Calendar", ()=>Calendar);
parcelHelpers.export(exports, "CalendarHeader", ()=>CalendarHeader);
parcelHelpers.export(exports, "CalendarGrid", ()=>CalendarGrid);
parcelHelpers.export(exports, "CalendarButton", ()=>CalendarButton);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("./ActionButton");
var _calendar = require("react-aria-components/Calendar");
var _date = require("@internationalized/date");
var _s2IconChevronLeft20NSvg = require("../s2wf-icons/S2_Icon_ChevronLeft_20_N.svg");
var _s2IconChevronLeft20NSvgDefault = parcelHelpers.interopDefault(_s2IconChevronLeft20NSvg);
var _s2IconChevronRight20NSvg = require("../s2wf-icons/S2_Icon_ChevronRight_20_N.svg");
var _s2IconChevronRight20NSvgDefault = parcelHelpers.interopDefault(_s2IconChevronRight20NSvg);
var _slots = require("react-aria-components/slots");
var _content = require("./Content");
var _field = require("./Field");
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _pressScale = require("./pressScale");
var _rangeCalendar = require("react-aria-components/RangeCalendar");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("react-aria-components/Text");
var _i18Nprovider = require("react-aria/I18nProvider");
var _useLocalizedStringFormatter = require("react-aria/useLocalizedStringFormatter");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const CalendarContext = /*#__PURE__*/ (0, _react.createContext)(null);
const calendarStyles = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    rules += ' sd18';
    if (props.isMultiMonth) rules += ' -_4DHzJc-e4mUs18';
    else rules += ' -_4DHzJc-0u6p5b18';
    rules += ' _ta18';
    rules += ' Us7Vxmb18';
    rules += ' qs7Vxmb18';
    rules += ' __ca18';
    rules += ' -uq4sQ-Sp18';
    rules += ' -LnVzy-Z4dY0ec18';
    if (props.isMultiMonth) rules += ' -cYDWLb-ZFFQGNb18';
    else rules += ' -cYDWLb-ZnqRBTd18';
    if (props.isMultiMonth) {
        if (!width) rules += ' ZJ18';
    } else if (!width) rules += ' ZRqDA2c18';
    if (props.isMultiMonth) {
        if (!maxWidth) rules += ' Le4mUs18';
    } else if (!maxWidth) rules += ' La18';
    return rules;
};
const headerStyles = " sd18 eb18 _Ce18 qs7Vxmb18";
const headingStyles = " sd18 eb18 _Ce18 JYB8I18 GYB8I18 IYB8I18 HYB8I18 _ub18 Za18";
const titleStyles = " uk18 ucJ9TBTb18 ud3Euai18 uea18 ugb18 uhd18 uje18 u2NhKxcl18 uic18 -_6BNtrc-e18 vFHT6Dd18 xd18 _xa18 xX0cczbc18 _xX0cczba18 xfd18 _xfa18 xfX0cczbc18 _xfX0cczba18 _Fd18 _FnuYUweb18 po18 _Wa18 _ub18 _va18 JYB8I18 GYB8I18";
const headerCellStyles = " uk18 ucJ9TBTb18 ud3Euai18 uea18 ugb18 uhd18 uje18 u2NhKxcl18 uic18 -_6BNtrc-c18 vFHT6Dd18 xd18 _xa18 xX0cczbc18 _xX0cczba18 xfd18 _xfa18 xfX0cczbc18 _xfX0cczba18 _Fd18 _FnuYUweb18 po18 ri18 _Wa18 Sp18 Sbd18 Rp18 Rkd18 Qe18";
const cellStyles = function anonymous(props) {
    let rules = " ";
    rules += ' _Le18';
    rules += ' _ob18';
    if (props.isFirstChild) rules += ' Sd18';
    else rules += ' Sp18';
    if (props.isLastChild) rules += ' Rd18';
    else rules += ' Rp18';
    if (props.isFirstWeek) rules += ' Td18';
    else rules += ' Tj18';
    if (props.isLastWeek) rules += ' Qd18';
    else rules += ' Qj18';
    rules += ' _Pc18';
    if (props.isOutsideMonth) rules += ' sk18';
    else rules += ' sd18';
    rules += ' eb18';
    rules += ' _Ca18';
    rules += ' __ca18';
    rules += ' Z0q26ub18';
    rules += ' F0q26ub18';
    return rules;
};
const cellInnerStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf18';
    else rules += ' _Le18';
    rules += ' Oh18';
    rules += ' OlOVIhfcebS7sd18';
    rules += ' OlOVIhfcebS7sd18';
    rules += ' _Mc18';
    if (props.isSelectionEnd) rules += ' _Kd18';
    else if (props.isSelectionStart) rules += ' _Kd18';
    else if (props.isSelected) {
        if (props.selectionMode === "range") rules += ' _Kb18';
        else if (props.selectionMode === "single") rules += ' _Kd18';
    } else rules += ' _Kb18';
    rules += ' Yd18';
    rules += ' YlOVIhfce18';
    rules += ' YlOVIhfce18';
    rules += ' Xb18';
    rules += ' XlOVIhfcb18';
    rules += ' XlOVIhfcb18';
    rules += ' _2b18';
    rules += ' _2lOVIhfcb18';
    rules += ' _2lOVIhfcb18';
    rules += ' _Pc18';
    rules += ' uk18';
    rules += ' ucJ9TBTb18';
    rules += ' ud3Euai18';
    rules += ' uea18';
    rules += ' ugb18';
    rules += ' uhd18';
    rules += ' uje18';
    rules += ' u2NhKxcl18';
    rules += ' uic18';
    rules += ' -_6BNtrc-c18';
    rules += ' vFHT6Dd18';
    rules += ' xb18';
    rules += ' _xa18';
    rules += ' _Fb18';
    rules += ' _FnuYUwec18';
    if (props.isDisabled) rules += ' pp18';
    else if (props.isSelectionEnd) rules += ' px18';
    else if (props.isSelectionStart) rules += ' px18';
    else if (props.isSelected) {
        if (props.selectionMode === "range") rules += ' pt18';
        else rules += ' px18';
    } else rules += ' pt18';
    if (props.isDisabled) rules += ' plOVIhfcYMPQu18';
    else if (props.isSelectionEnd) rules += ' plOVIhfcgp5Dcd18';
    else if (props.isSelectionStart) rules += ' plOVIhfcgp5Dcd18';
    else if (props.isSelected) rules += ' plOVIhfcgp5Dcd18';
    else rules += ' plOVIhfc6LxY918';
    if (props.isDisabled) rules += ' plOVIhfcYMPQu18';
    else if (props.isSelectionEnd) rules += ' plOVIhfcgp5Dcd18';
    else if (props.isSelectionStart) rules += ' plOVIhfcgp5Dcd18';
    else if (props.isSelected) rules += ' plOVIhfcgp5Dcd18';
    else rules += ' plOVIhfc6LxY918';
    rules += ' ri18';
    rules += ' Za18';
    rules += ' Fb18';
    rules += ' og18';
    rules += ' ng18';
    rules += ' kg18';
    rules += ' jg18';
    rules += ' sd18';
    rules += ' eb18';
    rules += ' _Ca18';
    rules += ' _yb18';
    if (props.isSelectionEnd) {
        if (props.isInvalid) {
            if (props.isFocusVisible) {
                if (props.isUnavailable) rules += ' g7aei818';
                else rules += ' gYvV9s18';
            } else if (props.isPressed) rules += ' gYvV9s18';
            else if (props.isHovered) {
                if (props.isUnavailable) rules += ' g7aei818';
                else rules += ' gYvV9s18';
            } else rules += ' g7aei818';
        } else if (props.isDisabled) rules += ' g918';
        else if (props.isFocusVisible) rules += ' gUgARdd18';
        else if (props.isPressed) rules += ' gUgARdd18';
        else if (props.isHovered) rules += ' gUgARdd18';
        else rules += ' g5qAiPc18';
    } else if (props.isSelectionStart) {
        if (props.isInvalid) {
            if (props.isFocusVisible) {
                if (props.isUnavailable) rules += ' g7aei818';
                else rules += ' gYvV9s18';
            } else if (props.isPressed) rules += ' gYvV9s18';
            else if (props.isHovered) {
                if (props.isUnavailable) rules += ' g7aei818';
                else rules += ' gYvV9s18';
            } else rules += ' g7aei818';
        } else if (props.isDisabled) rules += ' g918';
        else if (props.isFocusVisible) rules += ' gUgARdd18';
        else if (props.isPressed) rules += ' gUgARdd18';
        else if (props.isHovered) rules += ' gUgARdd18';
        else rules += ' g5qAiPc18';
    } else if (props.isSelected) {
        if (props.selectionMode === "range") {
            if (props.isHovered) {
                if (props.isInvalid) {
                    if (props.isUnavailable) rules += ' g918';
                    else rules += ' gJj9Tpd18';
                } else rules += ' gNAacne18';
            }
        } else if (props.selectionMode === "single") {
            if (props.isInvalid) {
                if (props.isFocusVisible) rules += ' gYvV9s18';
                else if (props.isPressed) rules += ' gYvV9s18';
                else if (props.isHovered) rules += ' gYvV9s18';
                else rules += ' g7aei818';
            } else if (props.isDisabled) rules += ' g918';
            else if (props.isFocusVisible) rules += ' gUgARdd18';
            else if (props.isPressed) rules += ' gUgARdd18';
            else if (props.isHovered) rules += ' gUgARdd18';
            else rules += ' g5qAiPc18';
        }
    } else if (props.isDisabled) rules += ' g918';
    else if (props.isPressed) rules += ' gH18';
    else if (props.isHovered) {
        if (props.isUnavailable) rules += ' g918';
        else rules += ' gH18';
    } else rules += ' g918';
    if (props.isUnavailable) rules += ' glOVIhfc918';
    else if (props.isSelectionEnd) rules += ' glOVIhfcebS7sd18';
    else if (props.isSelectionStart) rules += ' glOVIhfcebS7sd18';
    else if (props.isSelected) {
        if (props.selectionMode === "range") {
            if (props.isHovered) rules += ' glOVIhfcebS7sd18';
        } else if (props.selectionMode === "single") rules += ' glOVIhfcebS7sd18';
    } else if (props.isHovered) rules += ' glOVIhfcebS7sd18';
    else rules += ' glOVIhfc918';
    if (props.isUnavailable) rules += ' glOVIhfc918';
    else if (props.isSelectionEnd) rules += ' glOVIhfcebS7sd18';
    else if (props.isSelectionStart) rules += ' glOVIhfcebS7sd18';
    else if (props.isSelected) {
        if (props.selectionMode === "range") {
            if (props.isHovered) rules += ' glOVIhfcebS7sd18';
        } else if (props.selectionMode === "single") rules += ' glOVIhfcebS7sd18';
    } else if (props.isHovered) rules += ' glOVIhfcebS7sd18';
    else rules += ' glOVIhfc918';
    return rules;
};
const todayStyles = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa18';
    rules += ' _lakDin18';
    rules += ' _EF18';
    rules += ' _ZRWeLS18';
    rules += ' ZPcYW6d18';
    rules += ' FPcYW6d18';
    rules += ' og18';
    rules += ' ng18';
    rules += ' kg18';
    rules += ' jg18';
    rules += ' g5ZbAob18';
    if (props.isToday) rules += ' sb18';
    else rules += ' sk18';
    return rules;
};
const unavailableStyles = " _Pa18 WzErnCb18 _EjhYzGc18 _RjhYzGc18 FkqjWPe18 _ZN7ydnb18 og18 ng18 kg18 jg18 g5ZbAob18";
const selectionBackgroundStyles = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa18';
    rules += ' _9a18';
    rules += ' Wr18';
    if (props.isPreviousDayNotSelected) rules += ' _Ar18';
    else if (props.isSelectionStart) rules += ' _Ar18';
    else if (props.isFirstDayInWeek) rules += ' _Ar18';
    else rules += ' _Al18';
    if (props.isNextDayNotSelected) rules += ' _zr18';
    else if (props.isSelectionEnd) rules += ' _zr18';
    else if (props.isLastDayInWeek) rules += ' _zr18';
    else rules += ' _zl18';
    rules += ' _lr18';
    if (props.isPreviousDayNotSelected) rules += ' og18';
    else if (props.isSelectionStart) rules += ' og18';
    else if (props.isFirstDayInWeek) rules += ' og18';
    else rules += ' od18';
    if (props.isPreviousDayNotSelected) rules += ' kg18';
    else if (props.isSelectionStart) rules += ' kg18';
    else if (props.isFirstDayInWeek) rules += ' kg18';
    else rules += ' kd18';
    if (props.isNextDayNotSelected) rules += ' ng18';
    else if (props.isSelectionEnd) rules += ' ng18';
    else if (props.isLastDayInWeek) rules += ' ng18';
    else rules += ' nd18';
    if (props.isNextDayNotSelected) rules += ' jg18';
    else if (props.isSelectionEnd) rules += ' jg18';
    else if (props.isLastDayInWeek) rules += ' jg18';
    else rules += ' jd18';
    if (props.isInvalid) rules += ' gZbQnx18';
    else rules += ' gG18';
    rules += ' glOVIhfcebS7sd18';
    rules += ' glOVIhfcebS7sd18';
    rules += ' _yb18';
    return rules;
};
const selectionBorderStyles = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa18';
    rules += ' _9c18';
    rules += ' Wr18';
    if (props.isPreviousDayNotSelected) rules += ' _Ar18';
    else if (props.isSelectionStart) rules += ' _Ar18';
    else if (props.isFirstDayInWeek) rules += ' _Ar18';
    else rules += ' _Al18';
    if (props.isNextDayNotSelected) rules += ' _zr18';
    else if (props.isSelectionEnd) rules += ' _zr18';
    else if (props.isLastDayInWeek) rules += ' _zr18';
    else rules += ' _zl18';
    rules += ' _lr18';
    if (props.isPreviousDayNotSelected) rules += ' mb18';
    else if (props.isSelectionStart) rules += ' mb18';
    else if (props.isFirstDayInWeek) rules += ' mb18';
    else rules += ' ma18';
    rules += ' _kb18';
    if (props.isNextDayNotSelected) rules += ' lb18';
    else if (props.isSelectionEnd) rules += ' lb18';
    else if (props.isLastDayInWeek) rules += ' lb18';
    else rules += ' la18';
    rules += ' hb18';
    rules += ' _jf18';
    if (props.isInvalid) rules += ' ip18';
    else rules += ' ix18';
    rules += ' ilOVIhfc6LxY918';
    rules += ' ilOVIhfc6LxY918';
    if (props.isPreviousDayNotSelected) rules += ' og18';
    else if (props.isSelectionStart) rules += ' og18';
    else if (props.isFirstDayInWeek) rules += ' og18';
    else rules += ' od18';
    if (props.isPreviousDayNotSelected) rules += ' kg18';
    else if (props.isSelectionStart) rules += ' kg18';
    else if (props.isFirstDayInWeek) rules += ' kg18';
    else rules += ' kd18';
    if (props.isNextDayNotSelected) rules += ' ng18';
    else if (props.isSelectionEnd) rules += ' ng18';
    else if (props.isLastDayInWeek) rules += ' ng18';
    else rules += ' nd18';
    if (props.isNextDayNotSelected) rules += ' jg18';
    else if (props.isSelectionEnd) rules += ' jg18';
    else if (props.isLastDayInWeek) rules += ' jg18';
    else rules += ' jd18';
    return rules;
};
const Calendar = /*#__PURE__*/ (0, _react.forwardRef)(function Calendar(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, CalendarContext);
    let { visibleMonths = 1, errorMessage, UNSAFE_style, UNSAFE_className, styles, ...otherProps } = props;
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let isMultiMonth = visibleMonths > 1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.Calendar), {
        ...otherProps,
        ref: ref,
        visibleDuration: {
            months: visibleMonths
        },
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + calendarStyles({
            isMultiMonth
        }, styles),
        children: ({ isInvalid, isDisabled })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
                        values: [
                            [
                                (0, _content.HeaderContext),
                                null
                            ],
                            [
                                (0, _content.HeadingContext),
                                null
                            ]
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarHeader, {
                            visibleMonths: visibleMonths
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " sd18 _tc18 Us7Vxmb18 qs7Vxmb18 Za18 ed18",
                        children: Array.from({
                            length: visibleMonths
                        }).map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarGrid, {
                                months: i
                            }, i))
                    }),
                    isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        slot: "errorMessage",
                        className: (0, _field.helpTextStyles)({
                            isInvalid,
                            isDisabled,
                            size: 'M'
                        }),
                        children: errorMessage || stringFormatter.format('calendar.invalidSelection', {
                            selectedCount: 1
                        })
                    })
                ]
            });
        }
    });
});
const CalendarHeader = ({ visibleMonths })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Header), {
        styles: headerStyles,
        children: Array.from({
            length: visibleMonths
        }).map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: headingStyles,
                children: [
                    i === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarButton, {
                        slot: "previous",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconChevronLeft20NSvgDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarHeading), {
                        offset: {
                            months: i
                        },
                        className: titleStyles
                    }),
                    i === visibleMonths - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarButton, {
                        slot: "next",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconChevronRight20NSvgDefault.default), {})
                    })
                ]
            }, i))
    });
};
const CalendarGrid = (props)=>{
    let rangeCalendarProps = (0, _slots.useSlottedContext)((0, _rangeCalendar.RangeCalendarContext));
    let calendarProps = (0, _slots.useSlottedContext)((0, _calendar.CalendarContext));
    let firstDayOfWeek = rangeCalendarProps?.firstDayOfWeek ?? calendarProps?.firstDayOfWeek;
    // use isolation to start a new stacking context so that we can use zIndex -1 for the selection span.
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _calendar.CalendarGrid), {
        className: " __na18 __oYB8I18 _Bb18",
        offset: {
            months: props.months
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarGridHeader), {
                className: "",
                children: (day)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarHeaderCell, {
                        children: day
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarGridBody), {
                className: "",
                children: (date)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarCell, {
                        date: date,
                        firstDayOfWeek: firstDayOfWeek
                    })
            })
        ]
    });
};
const CalendarButton = (props1)=>{
    let { direction } = (0, _i18Nprovider.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: function anonymous(props) {
            let rules = " ";
            if (props.direction === "rtl") {
                rules += ' -Z4Pn4c-a18';
                rules += ' __Ha18';
            }
            if (props.direction === "rtl") {
                rules += ' -_04Pn4c-a18';
                rules += ' __Ha18';
            }
            return rules;
        }({
            direction
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
            ...props1,
            isQuiet: true,
            children: props1.children
        })
    });
};
const CalendarHeaderCell = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarHeaderCell), {
        className: headerCellStyles,
        children: props.children
    });
};
const CalendarCell = (props)=>{
    let { locale } = (0, _i18Nprovider.useLocale)();
    let firstDayOfWeek = props.firstDayOfWeek;
    // Calculate the day and week index based on the date.
    let { dayIndex, weekIndex, lastWeekIndex } = useWeekAndDayIndices(props.date, locale, firstDayOfWeek);
    let calendarStateContext = (0, _react.useContext)((0, _calendar.CalendarStateContext));
    let rangeCalendarStateContext = (0, _react.useContext)((0, _rangeCalendar.RangeCalendarStateContext));
    let state = calendarStateContext ?? rangeCalendarStateContext;
    let isFirstWeek = weekIndex === 0;
    let isLastWeek = weekIndex === lastWeekIndex;
    let isFirstChild = dayIndex === 0;
    let isLastChild = dayIndex === 6;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarCell), {
        date: props.date,
        className: (renderProps)=>cellStyles({
                ...renderProps,
                isFirstChild,
                isLastChild,
                isFirstWeek,
                isLastWeek
            }),
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarCellInner, {
                ...props,
                weekIndex: weekIndex,
                dayIndex: dayIndex,
                state: state,
                isRangeSelection: !!rangeCalendarStateContext,
                renderProps: renderProps
            })
    });
};
const CalendarCellInner = (props)=>{
    let { dayIndex, date, renderProps, state, isRangeSelection } = props;
    let ref = (0, _react.useRef)(null);
    let { isUnavailable, formattedDate, isSelected, isSelectionStart, isSelectionEnd, isInvalid } = renderProps;
    // only apply the selection start/end styles if the start/end date is actually selectable (aka not unavailable)
    // or if the range is invalid and thus we still want to show the styles even if the start/end date is an unavailable one
    isSelectionStart = isSelectionStart && (!isUnavailable || isInvalid);
    isSelectionEnd = isSelectionEnd && (!isUnavailable || isInvalid);
    let isDateInRange = (checkDate)=>{
        if (!('highlightedRange' in state) || !state.highlightedRange) return state.isSelected(checkDate);
        // if invalid, check if date is within the full range boundaries
        if (isInvalid) return checkDate.compare(state.highlightedRange.start) >= 0 && checkDate.compare(state.highlightedRange.end) <= 0;
        return state.isSelected(checkDate);
    };
    let prevDay = date.subtract({
        days: 1
    });
    let nextDay = date.add({
        days: 1
    });
    let isFirstDayInWeek = dayIndex === 0;
    let isLastDayInWeek = dayIndex === 6;
    let isPreviousDayNotSelected = !prevDay || !isDateInRange(prevDay) || prevDay.month !== props.date.month;
    let isNextDayNotSelected = !nextDay || !isDateInRange(nextDay) || nextDay.month !== props.date.month;
    // when invalid, show background for all selected dates (including unavailable) to make continuous range appearance
    // when valid, only show background for available selected dates
    let isBackgroundStyleApplied = isSelected && isRangeSelection && (isInvalid || !isUnavailable) && (isDateInRange(prevDay) || nextDay.month === date.month && isDateInRange(nextDay));
    // oxlint-disable react/react-compiler
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " _Pc18 Za18 Fb18",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: ref,
                style: (0, _pressScale.pressScale)(ref, {})(renderProps),
                className: cellInnerStyles({
                    ...renderProps,
                    isSelectionStart,
                    isSelectionEnd,
                    selectionMode: isRangeSelection ? 'range' : 'single'
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: todayStyles(renderProps),
                        role: "presentation"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: formattedDate
                    }),
                    isUnavailable && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: unavailableStyles,
                        role: "presentation"
                    })
                ]
            }),
            isBackgroundStyleApplied && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: selectionBackgroundStyles({
                    isInvalid,
                    isFirstDayInWeek,
                    isLastDayInWeek,
                    isSelectionStart,
                    isSelectionEnd,
                    isPreviousDayNotSelected,
                    isNextDayNotSelected
                }),
                role: "presentation"
            }),
            isBackgroundStyleApplied && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: selectionBorderStyles({
                    isInvalid,
                    isFirstDayInWeek,
                    isLastDayInWeek,
                    isSelectionStart,
                    isSelectionEnd,
                    isPreviousDayNotSelected,
                    isNextDayNotSelected
                }),
                role: "presentation"
            })
        ]
    });
// oxlint-enable react/react-compiler
};
/**
 * Calculate the week index (0-based) and day index (0-based) for a given date within a month in a
 * calendar.
 *
 * @param date - The date to calculate indices for.
 * @param locale - The locale string (e.g., 'en-US', 'fr-FR', 'hi-IN-u-ca-indian').
 * @param firstDayOfWeek - Optional override for the first day of the week ('sun', 'mon', 'tue',
 *   etc.).
 * @returns Object with weekIndex and dayIndex.
 */ function useWeekAndDayIndices(date, locale, firstDayOfWeek) {
    let result = (0, _react.useMemo)(()=>{
        // Get the day index within the week (0-6)
        const dayIndex = (0, _date.getDayOfWeek)(date, locale, firstDayOfWeek);
        const monthStart = (0, _date.startOfMonth)(date);
        // Calculate the week index by finding which week this date falls into
        // within the month's calendar grid
        const monthStartDayOfWeek = (0, _date.getDayOfWeek)(monthStart, locale, firstDayOfWeek);
        const dayOfMonth = date.day;
        const weekIndex = Math.floor((dayOfMonth + monthStartDayOfWeek - 1) / 7);
        const lastDayOfMonth = (0, _date.startOfMonth)(date).add({
            months: 1
        }).subtract({
            days: 1
        });
        const lastWeekIndex = Math.floor((lastDayOfMonth.day + monthStartDayOfWeek - 1) / 7);
        return {
            weekIndex,
            lastWeekIndex,
            dayIndex
        };
    }, [
        date,
        locale,
        firstDayOfWeek
    ]);
    return result;
}

},{"0":"cLPRx","1":"jES3r","2":"61MRM","3":"7mAkH","4":"l6qdF","5":"4mcUD","6":"kguv0","7":"6Ktsx","8":"e8rdc","9":"htpZV","10":"eWjp3","11":"eTJWe","12":"ggFqC","13":"5RzMv","14":"5MJ5W","react/jsx-runtime":"2Is6Z","./ActionButton":"lNDRs","react-aria-components/Calendar":"2DleA","@internationalized/date":"1rmIt","../s2wf-icons/S2_Icon_ChevronLeft_20_N.svg":"5jnVm","../s2wf-icons/S2_Icon_ChevronRight_20_N.svg":"kmqkh","react-aria-components/slots":"bA6Cz","./Content":"10r6w","./Field":"eI7CE","../intl/*.json":"gDH3q","./pressScale":"8Ufux","react-aria-components/RangeCalendar":"2DleA","react":"a1TxN","react-aria-components/Text":"jt9fm","react-aria/I18nProvider":"l34Wn","react-aria/useLocalizedStringFormatter":"4LM0k","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cLPRx":[function() {},{}],"jES3r":[function() {},{}],"61MRM":[function() {},{}],"7mAkH":[function() {},{}],"l6qdF":[function() {},{}],"4mcUD":[function() {},{}],"kguv0":[function() {},{}],"6Ktsx":[function() {},{}],"e8rdc":[function() {},{}],"htpZV":[function() {},{}],"eWjp3":[function() {},{}],"eTJWe":[function() {},{}],"ggFqC":[function() {},{}],"5RzMv":[function() {},{}],"5MJ5W":[function() {},{}],"l2Cjd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateFieldContext", ()=>DateFieldContext);
parcelHelpers.export(exports, "DateField", ()=>DateField);
parcelHelpers.export(exports, "DateInputContainer", ()=>DateInputContainer);
parcelHelpers.export(exports, "DateInput", ()=>DateInput);
parcelHelpers.export(exports, "InvalidIndicator", ()=>InvalidIndicator);
var _jsxRuntime = require("react/jsx-runtime");
var _dateField = require("react-aria-components/DateField");
var _react = require("react");
var _field = require("./Field");
var _form = require("react-aria-components/Form");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const DateFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const segmentContainer = " _ub18 _vb18 Na18 Fb18 _Na18 Pc18 -dLGswc-h3TDrc18 sd18 eb18 __Wb18";
const dateSegment = function anonymous(props) {
    let rules = " ";
    rules += ' _Le18';
    rules += ' -zNggOc-RWHrbc18';
    if (props.isFocused) rules += ' g_h18';
    else rules += ' g918';
    if (props.isFocused) rules += ' glOVIhfcebS7sd18';
    else rules += ' glOVIhfc918';
    if (props.isFocused) rules += ' glOVIhfcebS7sd18';
    else rules += ' glOVIhfc918';
    if (props.isFocused) rules += ' px18';
    if (props.isFocused) rules += ' plOVIhfcgp5Dcd18';
    if (props.isFocused) rules += ' plOVIhfcgp5Dcd18';
    rules += ' oLvNfn18';
    rules += ' nLvNfn18';
    rules += ' kLvNfn18';
    rules += ' jLvNfn18';
    if (props.isPunctuation) rules += ' Sd18';
    else rules += ' Sj18';
    if (props.isPunctuation) rules += ' Rd18';
    else rules += ' Rj18';
    rules += ' Tj18';
    rules += ' Qj18';
    rules += ' _yb18';
    return rules;
};
const iconStyles = " sd18 eb18 _Cb18";
const DateField = /*#__PURE__*/ (0, _react.forwardRef)(function DateField(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, DateFieldContext);
    let { label, contextualHelp, description: descriptionMessage, errorMessage, isRequired, size = 'M', labelPosition = 'top', necessityIndicator, labelAlign = 'start', UNSAFE_style, UNSAFE_className, styles, ...dateFieldProps } = props1;
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateField), {
        ref: ref,
        isRequired: isRequired,
        ...dateFieldProps,
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se18';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU18';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG18';
                }
            }
            if (props.isInForm) rules += ' DLwlgod18';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb18';
                else if (props.labelPosition === "top") rules += ' DM8Mfn18';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb18';
            else if (props.labelPosition === "top") rules += ' E4w1sLc18';
            if (props.labelPosition === "side") rules += ' CbRM95c18';
            else if (props.labelPosition === "top") rules += ' Cxaocre18';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e18';
                rules += ' vFHT6Dd18';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d18';
                rules += ' vFHT6Dd18';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b18';
                rules += ' vFHT6Dd18';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a18';
                rules += ' vFHT6Dd18';
            } else {
                rules += ' -_6BNtrc-c18';
                rules += ' vFHT6Dd18';
            }
            rules += ' ea18';
            rules += ' _Fd18';
            rules += ' _FnuYUweb18';
            if (props.size === "XL") rules += ' -BhX7R-FBaYFfc18';
            else if (props.size === "L") rules += ' -BhX7R-F3JjxG18';
            else if (props.size === "S") rules += ' -BhX7R-FCe2o8c18';
            else if (props.size === "XS") rules += ' -BhX7R-FifsFYc18';
            else rules += ' -BhX7R-F4dY0ec18';
            rules += ' -AJjOLd-UVkF0Db18';
            rules += ' qi9a9Xd18';
            rules += ' __ca18';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, styles),
        children: ({ isDisabled, isInvalid })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        role: "presentation",
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr18';
                            rules += ' yXcEWr18';
                            rules += ' BXcEWr18';
                            rules += ' AXcEWr18';
                            if (props.size === "XL") rules += ' NBaYFfc18';
                            else if (props.size === "L") rules += ' N3JjxG18';
                            else if (props.size === "S") rules += ' NCe2o8c18';
                            else if (props.size === "XS") rules += ' NifsFYc18';
                            else rules += ' N4dY0ec18';
                            if (props.isQuiet) rules += ' _qd18';
                            else rules += ' _qtb18';
                            if (props.size === "XL") rules += ' -Anxdcc-ZIqJukc18';
                            else if (props.size === "L") rules += ' -Anxdcc-ZbuJPjc18';
                            else if (props.size === "S") rules += ' -Anxdcc-Z7AJvic18';
                            else rules += ' -Anxdcc-ZExJajc18';
                            rules += ' __v6TNLWb18';
                            rules += ' __Wb18';
                            rules += ' SMBFGYc18';
                            rules += ' RfBFGYc18';
                            rules += ' -S_-Sv18';
                            rules += ' -R_-Rv18';
                            return rules;
                        }({
                            size
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInputContainer, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(InvalidIndicator, {
                                isInvalid: isInvalid,
                                isDisabled: isDisabled
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: errorMessage
                    })
                ]
            });
        }
    });
});
function DateInputContainer(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: segmentContainer,
        children: props.children
    });
}
function DateInput(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
        className: "",
        ...props,
        children: (segment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateSegment), {
                segment: segment,
                className: (renderProps)=>dateSegment({
                        ...renderProps,
                        isPunctuation: segment.type === 'literal'
                    })
            })
    });
}
function InvalidIndicator(props) {
    return props.isInvalid ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: iconStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldErrorIcon), {
            isDisabled: props.isDisabled
        })
    }) : null;
}

},{"0":"2ueem","1":"8ZPUF","2":"iADjS","3":"5blUZ","4":"bw8YO","react/jsx-runtime":"2Is6Z","react-aria-components/DateField":"5wv9P","react":"a1TxN","./Field":"eI7CE","react-aria-components/Form":"g7RKA","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2ueem":[function() {},{}],"8ZPUF":[function() {},{}],"iADjS":[function() {},{}],"5blUZ":[function() {},{}],"bw8YO":[function() {},{}],"fEve7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangeCalendarContext", ()=>RangeCalendarContext);
parcelHelpers.export(exports, "RangeCalendar", ()=>RangeCalendar);
var _jsxRuntime = require("react/jsx-runtime");
var _rangeCalendar = require("react-aria-components/RangeCalendar");
var _calendar = require("./Calendar");
var _slots = require("react-aria-components/slots");
var _react = require("react");
var _content = require("./Content");
var _field = require("./Field");
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _text = require("react-aria-components/Text");
var _useLocalizedStringFormatter = require("react-aria/useLocalizedStringFormatter");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const RangeCalendarContext = /*#__PURE__*/ (0, _react.createContext)(null);
const calendarStyles = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    rules += ' sd18';
    if (props.isMultiMonth) rules += ' -_4DHzJc-e4mUs18';
    else rules += ' -_4DHzJc-0u6p5b18';
    rules += ' _ta18';
    rules += ' Us7Vxmb18';
    rules += ' qs7Vxmb18';
    rules += ' __ca18';
    rules += ' -uq4sQ-Sp18';
    rules += ' -LnVzy-Z4dY0ec18';
    if (props.isMultiMonth) rules += ' -cYDWLb-ZFFQGNb18';
    else rules += ' -cYDWLb-ZnqRBTd18';
    if (props.isMultiMonth) {
        if (!width) rules += ' ZJ18';
    } else if (!width) rules += ' ZRqDA2c18';
    if (props.isMultiMonth) {
        if (!maxWidth) rules += ' Le4mUs18';
    } else if (!maxWidth) rules += ' La18';
    return rules;
};
const RangeCalendar = /*#__PURE__*/ (0, _react.forwardRef)(function RangeCalendar(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, RangeCalendarContext);
    let { visibleMonths = 1, errorMessage, UNSAFE_style, UNSAFE_className, styles, ...otherProps } = props;
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let isMultiMonth = visibleMonths > 1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rangeCalendar.RangeCalendar), {
        ...otherProps,
        ref: ref,
        visibleDuration: {
            months: visibleMonths
        },
        style: {
            ...UNSAFE_style,
            '--num-calendars': visibleMonths
        },
        className: (UNSAFE_className || '') + calendarStyles({
            isMultiMonth
        }, styles),
        children: ({ isInvalid, isDisabled })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
                        values: [
                            [
                                (0, _content.HeaderContext),
                                null
                            ],
                            [
                                (0, _content.HeadingContext),
                                null
                            ]
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarHeader), {
                            visibleMonths: visibleMonths
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " sd18 _tc18 Us7Vxmb18 qs7Vxmb18 ed18",
                        children: Array.from({
                            length: visibleMonths
                        }).map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarGrid), {
                                months: i
                            }, i))
                    }),
                    isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        slot: "errorMessage",
                        className: (0, _field.helpTextStyles)({
                            isInvalid,
                            isDisabled,
                            size: 'M'
                        }),
                        children: errorMessage || stringFormatter.format('calendar.invalidSelection', {
                            selectedCount: 2
                        })
                    })
                ]
            });
        }
    });
});

},{"0":"idi5K","1":"eR6vB","react/jsx-runtime":"2Is6Z","react-aria-components/RangeCalendar":"2DleA","./Calendar":"j5ASf","react-aria-components/slots":"bA6Cz","react":"a1TxN","./Content":"10r6w","./Field":"eI7CE","../intl/*.json":"gDH3q","react-aria-components/Text":"jt9fm","react-aria/useLocalizedStringFormatter":"4LM0k","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"idi5K":[function() {},{}],"eR6vB":[function() {},{}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=CheckboxGroup.fc36f63c.js.map
